const RELOAD_COUNTER_KEY = '@templafy/request-service/app-version-reload-counter';
const MAX_RELOAD_PER_HOUR = 5;
const ONE_HOUR_IN_MS = 3600000;
class ApplicationVersionInvalidInterceptor {
    onError(error) {
        if (428 !== error.statusCode) return Promise.reject(error);
        let firstReloadDateISO = new Date().toISOString();
        let count = 0;
        try {
            const reloadCounterItem = localStorage.getItem(RELOAD_COUNTER_KEY);
            if (reloadCounterItem) {
                const reloadCounter = JSON.parse(reloadCounterItem);
                if (Date.now() - new Date(firstReloadDateISO).getTime() < ONE_HOUR_IN_MS) ({ firstReloadDateISO, count } = reloadCounter);
            }
        } catch  {}
        if (count < MAX_RELOAD_PER_HOUR) setReloadCounterAndReload({
            firstReloadDateISO,
            count: count + 1
        });
        return Promise.reject(error);
    }
}
const setReloadCounterAndReload = (reloadCounter)=>{
    localStorage.setItem(RELOAD_COUNTER_KEY, JSON.stringify(reloadCounter));
    globalThis.location.reload();
};
export { ApplicationVersionInvalidInterceptor };
